<div class="modal-body p-3">
  <app-pie-chart
    [header]="header()"
    [subHeader]="subHeader()"
    [labelKey]="labelKey()"
    [valueKey]="valueKey()"
    [valueFormattedKey]="valueFormattedKey()"
    [tooltipKey]="tooltipKey()"
    [showLegend]="showLegend()"
    [data]="data()"
    [pieChartSize]="pieChartSize()"
    (togglePreview)="onClose()"
  ></app-pie-chart>
</div>
